// extracted by mini-css-extract-plugin
export default {"paragraphWhite":"paragraph_paragraphWhite__OvN0H","paragraph":"paragraph_paragraph__GRIU5"};